<template>
    <div ref="popupContainer">
		<vs-popup :active.sync="showValidationPopup" title="Êtes-vous sûr de vouloir supprimer cette mission ?" style="z-index: 54001;">
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
				<vs-button class="mt-2 w-full" @click="acceptDeleteMission()">Oui</vs-button>
				</div>
				<div class="vx-col sm:w-1/2">
				<vs-button class="mt-2 w-full" @click="declineDeleteMission()">Non</vs-button>
				</div>
			</div>
		</vs-popup>
      <vs-popup :active.sync="showUpdateMissionPopup" title="Modification de la mission" :button-close-hidden="true" style="z-index: 54100;">
        <div style="padding: 0 20px;">
          <MissionForContract
            v-if="showUpdateMissionPopup"
            :contract="contract"
            :missionToModify="mission"
            :show="clickAddMission"
            :apiUrl="apiUrl"
            :router="router"
            :editMode="isEdit"
            @close-form="showUpdateMissionPopup = false"
            @close-form-after-added="refreshMissions()"
          />
        </div>
      </vs-popup>
    <vs-popup :active.sync="showInfoPopup" title="Informations supplémentaires" style="z-index: 54003;">
      <div class="vx-row pb-3" style="white-space: nowrap;">
        <div class="vx-col">
          Temps maxi à passer par mois : {{ maxTimeValue }}
        </div>
        <div class="vx-col">
          Prix Collaborateur externe : {{ provider_price_textValue }}
        </div>
        <div class="vx-col">
          Nombre de points par mois avec le client : {{ meeting_number }}
        </div>
        <div class="vx-col">
          Budget maximum : {{ max_budget }}
        </div>
      </div>
	  <hr></hr>
	  <!-- CONTENT PART -->
	  <div class="pt-3" style="font-weight: 600;">CONTENT</div>
	  <div class="vx-row" style="white-space: nowrap;">
		<div class="vx-col">
          Nombre du pages  : {{ num_pages }}
        </div>
        <div class="vx-col">
          Numero du mots  : {{ num_words }}
        </div>
        <div class="vx-col">
          Langue : {{ language }}
        </div>
        <div class="vx-col">
			Complexité : {{ difficulty }}
        </div>
      </div>
	  <!-- CONTENT PART -->
    </vs-popup>
    <vs-table
		:data="missionData"
		class="mt-4"
		:key="refreshMissionsList"
		noDataText="Pas de prestation"
    >
      <template slot="thead">
        <vs-th class="bgcolor white-txt pdl0" style="width: 40px;"><div class="w-full text-center">　#</div></vs-th>
        <vs-th class="bgcolor white-txt pdl0">PRESTATIONS</vs-th>
        <vs-th class="bgcolor white-txt pdl0">BRIEF</vs-th>
        <vs-th class="bgcolor white-txt pdl0">COMMENTAIRES <br>
		FACTURATION</vs-th>
        <vs-th class="bgcolor white-txt"><div class="w-full text-center">CONSULTANT</div></vs-th>
        <vs-th class="bgcolor white-txt pdl0">RÉCURRENCE</vs-th>
        <vs-th class="bgcolor white-txt"><div class="w-full text-right">{{activeUser.userRole == '171' ? "TARIF COLLABORATEUR" : "TARIF"}}</div></vs-th>
		<vs-th v-if="activeUser.userRole == '171'" class="bgcolor white-txt pdl0"><div class="w-full text-center">Nb. de points/mois</div></vs-th>
        <vs-th class="bgcolor white-txt"><div class="w-full text-right">DÉBUT</div></vs-th>
        <vs-th class="bgcolor white-txt"><div class="w-full text-right">FIN <br>ENGAGEMENT</div></vs-th>
        <!-- <vs-th class="bgcolor white-txt">Temps maxi</vs-th> -->
        <vs-th class="bgcolor white-txt pdl0"><div style="text-align: center; width: 100%;">STATUT</div></vs-th>
        <vs-th v-if="activeUser.role != '2' && activeUser.type != '7'" class="pdl0">ACTION</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="index" v-for="(row, index) in data">
						<vs-td class="text-center" style="cursor: pointer;">
							<vx-tooltip
							:text="row.id"
							position="top"
						>{{ row.products_number }}
						</vx-tooltip></vs-td>
			<vs-td style="font-weight: 700;">{{ getProductPrestation(row.products_id) }}</vs-td>
			<vs-td class="fw-bold commentary text-center">
				<div v-if = "row.comment_mission">
					<vx-tooltip :text = "row.comment_mission" class="cursor-pointer">
						<span class="material-symbols-outlined" style="color: #626262"
								>message</span
							>
					</vx-tooltip>
				</div>
			</vs-td>
			<vs-td class="fw-bold commentary text-center">
				<div v-if = "row.commentary">
					<vx-tooltip :text = "row.commentary" class="cursor-pointer">
						<span class="material-symbols-outlined" style="color: #626262"
								>message</span
							>
					</vx-tooltip>
				</div>
			</vs-td>
			<vs-td class="pdl0">
			    <div style="display: flex; justify-content: center;">
					<div class="vx-row center-content" v-if="row.acc_mang_id">
						<vx-tooltip
								:text="row.acc_mang_firstname.replace(/^\S/, s => s.toUpperCase()) + ' ' + row.acc_mang_lastname.toUpperCase()"
								position="top"
							>
							<vs-avatar
								style="border: 1px solid;"
								:text="row.acc_mang_firstname.substr(0, 1).toUpperCase() + row.acc_mang_lastname.substr(0, 1).toUpperCase()"
								:src="getCollaboratorAvatar(row.acc_mang_id)"
							/>
							</vx-tooltip>
					</div>
               </div>
          </vs-td>
          <vs-td v-if="row.recurrence"
            >{{ getContractFrequency(row.frequency) }}
          </vs-td>
          <vs-td v-else>One Shot</vs-td>
          <vs-td class="text-right" style="padding-right: 14px; font-weight: 700; white-space: nowrap;">{{ activeUser.userRole == '171' ? row.provider_price_text ? row.provider_price_text + " €" : "" : getPrice(row.price, row.price_text)  + (row.sold_percentage? "+"+row.sold_percentage +" %":"")}}</vs-td>
          <vs-td v-if="activeUser.userRole == '171'" class="text-center pdl0">{{ row.meeting_number }}</vs-td>
			<vs-td class="text-right" style="padding-right: 14px; cursor: pointer">{{ getDateToFrenchFormat(row.start_date) }}</vs-td>
			<vs-td class="text-right " :style="{ 'padding-right': '14px', 'color': row.is_warning ? 'orange' : 'default-color' , 'cursor': 'pointer'}">
			<div class="flex justify-around mt-3"> 
				<div class="flex justify-around">
				<div>{{ getDateToFrenchFormat(row.estimated_end_date) }}</div>
				
				<vs-icon  v-if="row.is_warning" icon="priority_high" size="medium" style="color:orange;"></vs-icon>
				</div>
			</div>
			</vs-td>



          <!-- <vs-td>{{ row.time_limit ? row.time_limit + "h" : " " }}</vs-td> -->
          <vs-td class="pdl0">
            <div class="flex center" style="padding-top: 3px;">
								<vs-chip
					style="width: 80px; margin-left: 10px; border-radius: 6px; padding-top: 2px;"
					:color="getContractStatusColor(row.status)">{{
					getContractStatus(row.status)
				}}</vs-chip>
            </div>
          </vs-td>
          <vs-td v-if="activeUser.role != '2' && activeUser.type != '7'">
				<el-dropdown>
					<vs-button class="btn-drop" icon-pack="feather" icon="icon-more-vertical" size="large"></vs-button>
					<el-dropdown-menu class="dropdown-menu">
						<el-dropdown-item @click="displayInfoPopup(row.time_limit, row.provider_price_text, row.meeting_number, row.max_budget, row.num_words, row.num_pages, row.difficulty, row.language)"><vs-button icon-pack="feather" icon="icon-eye" class="dropdown-btn">Détail</vs-button></el-dropdown-item>
						<el-dropdown-item @click="displayMissionForContract(row)"><vs-button icon-pack="feather" icon="icon-edit" class="dropdown-btn" style="margin-top: 5px;">Modifier</vs-button></el-dropdown-item>
						<el-dropdown-item v-if="$acl.check('sadmin')" @click="showDeletePopup(row)"><vs-button icon-pack="feather" icon="icon-trash-2" class="dropdown-btn" style="margin-top: 5px;">Supprimer</vs-button></el-dropdown-item>
					</el-dropdown-menu>
				</el-dropdown>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
  </div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import Mission from "@/entities/Mission";
import MissionForContract from "../forms/mission/MissionForContract";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";

export default {
	name: "MissionPopupTable",
	components: {
		MissionForContract,
	},
	props: {
		missions: Array,
		contract: {
			type: Object,
			default: null,
		},
		showupdate: {
			type: Boolean,
			default: false,
		},
	},
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			/*
			 * router: $router,
			 * allMissions: missions,
			 */
			isEdit: true,
			mission: null,
			missionToDelete: null,
			showInfoPopup: false,
			showValidationPopup: false,
			showUpdateMissionPopup: false,
			maxTimeValue: 0,
			provider_price_textValue: "",
			meeting_number: 0,
			max_budget: null,
			clickAddMission: false,
			nameConsultant: "Inconnu",
			is_leadConsultant: 0,
			missions_users: [],
			missionData: [],
			num_words: null,
			num_pages: null,
			difficulty: null,
			language: null,
			difficultList: [
				{ id: 1, name: "Standard" },
				{ id: 2, name: "Medium" },
				{ id: 3, name: "Premium" },
			],
			refreshMissionsList: 0,
		};
	},
	created() {
		this.getAllContracts();
		this.getAllProducts();
		this.getAllProductsCategories();
		this.getAllProductsSubCategories();
	},
	beforeUnmount() {
		// Find and remove any lingering tooltip elements
		const tooltips = document.querySelectorAll(".vx-tooltip-content");
		tooltips.forEach((tooltip) => tooltip.remove());
	},
	watch: {
		missions: {
			deep: true,
			handler: function (data) {
				//console.log("missions handler", data);

				this.missionData = [...data];

				if (data.length > 0) {
					this.$http
						.get(this.apiUrl + "contract/get/" + data[0].contract_id)
						.then((res) => {
							this.$emit("update-contract-data", res.data);
							// this.contract = res.data;
						});
				}

				// let queries = [];
				// for (let i = 0; i < this.missionData.length; i++) {
				// 	queries.push(this.getUIDList(this.missionData[i].id));
				// }

				// Promise.all(queries).then((responses) => {
				// 	let missions_users = [];
				// 	for (let response of responses) {
				// 		missions_users.push(response);
				// 	}
				// 	this.missions_users = [];
				// 	this.missions_users = missions_users;
				// 	this.refreshMissionsList++;
				// });
			},
		},
		/*
		 * clickAddMission: function(data){
		 *   if(data == false){
		 *     this.$emit("refresh-missions")
		 *   }
		 * }
		 */
	},
	computed: {
		redacLang: () => {
			return store.state.redac_lang;
		},
		products: () => {
			return store.state.products;
		},
		activeUser() {
			return VueCookies.get("userInfo");
		},
		allProductsCategories: () => {
			return store.state.products_categories;
		},
		allProductsSubCategories: () => {
			return store.state.products_sub_categories;
		},
		contracts: () => {
			return store.state.contracts;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
	},
	methods: {
		checkAMonthDate(estimatedEndDate) {
			if (estimatedEndDate) {
				const currentDate = new Date();
				const estimatedDate = new Date(estimatedEndDate);

				// Calculate the time difference in milliseconds
				const timeDifference = estimatedDate.getTime() - currentDate.getTime();

				// Convert milliseconds to days
				const daysDifference = timeDifference / (1000 * 3600 * 24);

				if (daysDifference < 30 || daysDifference === 0) {
					return true;
				} else {
					return false;
				}
			} else {
				return false;
			}
		},
		getPrice(price, txt) {
			if (price == 0) return "Offert";
			else if (price) {
				return this.formatThousandNumb(price) + "€";
			} else if (txt) return txt;
			else return "";
		},
		getUIDList(id) {
			return new Promise((resolve) => {
				this.$http
					.get(this.apiUrl + "mission/getuidlist/" + id)
					.then((result) => {
						resolve(result.data);
					})
					.catch((err) => {
						//console.log(err);
						resolve([]);
					});
			});
		},
		refreshMissions() {
			this.showValidationPopup = false;
			this.showUpdateMissionPopup = false;
			this.$nextTick(() => {
				this.$emit("refresh-missions", true);
			});
		},
		displayInfoPopup(
			maxTime,
			provider_price_text,
			meeting_number,
			max_budget,
			num_words,
			num_pages,
			difficulty,

			language
		) {
			let langObj = this.redacLang.filter((ele) => ele.id == language);
			let difObj = this.difficultList.filter((ele) => ele.id == difficulty);
			this.maxTimeValue = maxTime ? maxTime + "h" : "-";
			this.provider_price_textValue = provider_price_text
				? provider_price_text
				: "-";
			this.meeting_number = meeting_number ? meeting_number : 0;
			this.max_budget = max_budget ? max_budget : "-";
			this.num_words = num_words ? num_words : "-";
			this.num_pages = num_pages ? num_pages : "-";
			this.difficulty = difObj.length > 0 ? difObj[0].name : "-";
			this.language = langObj.length > 0 ? langObj[0].name : "-";
			this.showInfoPopup = true;
		},

		/*
		 * displayUpdatePopup(mission){
		 *   //console.log("mission_id", mission)
		 *   // SET MISSION
		 *   // MissionForContract
		 *   this.displayMissionForContract(true, mission)
		 *   // SHOW POPUP
		 *   // this.showInfoPopup = true
		 * },
		 */

		displayMissionForContract(mission = null) {
			// If contract status == 4
			if (mission) {
				let foundContract = this.contracts.findIndex(
					(row) => row.id == mission.contract_id
				);
				if (foundContract >= 0) {
					if (
						this.contracts[foundContract].status == 4 &&
						!this.$acl.check("sadmin")
					) {
						this.$vs.notify({
							title: "Echec",
							text: "Vous ne pouvez pas modifier les missions d'un contrat terminé.",
						});
					} else {
						this.router = this.$router;
						if (mission !== null) {
							let re = new RegExp("([T|Z])", "g");
							if (mission.start_date)
								mission.start_date = mission.start_date.replace(re, " ");
							if (mission.end_date)
								mission.end_date = mission.end_date.replace(re, " ");
						}
						this.mission = mission;
						this.clickAddMission = true;
						this.showUpdateMissionPopup = true;
					}
				}
			}
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		getAllContracts() {
			if (this.store) this.store.dispatch("getAllContracts");
			else store.dispatch("getAllContracts");
		},

		getAllProducts() {
			if (this.store) this.store.dispatch("getAllProducts");
			else store.dispatch("getAllProducts");
		},

		getAllProductsCategories() {
			store.dispatch("getAllProductsCategories");
		},

		getAllProductsSubCategories() {
			store.dispatch("getAllProductsSubCategories");
		},

		getProductShortDesc(productId) {
			let foundProduct = this.products.find(
				(product) => product.id == productId
			);
			return foundProduct.short_description;
		},

		getProductPrestation(productId) {
			let foundProduct = this.products.find(
				(product) => product.id == productId
			);
			return foundProduct.perform;
		},

		deleteMission(missionId) {
			Mission.delete(missionId, this.activeUser.id, (err, res) => {
				if (err) {
					this.$vs.notify({
						title: "Echec",
						color: "danger",
						text: "La mission n'a pas pu être supprimée.",
					});
				} else {
					this.$vs.notify({
						title: "Succès",
						text: "La mission a été supprimée avec succès.",
					});
					this.refreshMissions();
				}
			});
		},

		checkMissionHaveDoneTask(missionId) {
			return new Promise((resolve) => {
				this.$http
					.get(this.apiUrl + "task/getDoneTasksforMission/" + missionId)
					.then((result) => {
						resolve(result.data.length);
					})
					.catch((err) => {
						//console.log(err);
						resolve([]);
					});
			});
		},

		async showDeletePopup(mission) {
			let taskCount = await this.checkMissionHaveDoneTask(mission.id);
			if (taskCount > 0 || mission.status == 4) {
				this.$vs.notify({
					title: "Echec",
					text: "Vous ne pouvez pas supprimer une mission ayant déjà eu des tâches effectuées.",
				});
			} else {
				this.missionToDelete = mission.id;
				this.showValidationPopup = true;
			}
		},

		acceptDeleteMission() {
			this.deleteMission(this.missionToDelete);
			this.showValidationPopup = false;
		},

		declineDeleteMission() {
			this.missionToDelete = null;
			this.showValidationPopup = false;
		},
	},
};
</script>

<style>
.commentary {
	word-break: break-word;
}

.pdl0 {
	padding-left: 0 !important;
}
thead + tr {
	border: none !important;
}
thead > tr {
	background-color: #f3f2f7;
}
th > div {
	color: #6e6b7b;
	font-weight: normal;
	font-size: 11px;
	white-space: nowrap;
	margin: 10px;
}
.tr-values.vs-table--tr.tr-table-state-null {
	border-top: 1px solid rgb(235, 234, 238);
}
td {
	padding-left: 10px !important;
	color: black;
	font-size: 11px;
	font-weight: 500;
}
.vs-con-tbody.vs-table--tbody {
	border: none;
}

.btn-drop {
	display: inline;
	color: black;
	background-color: transparent !important;
	pointer-events: none;
}

.dropdown-btn {
	padding: 0 !important;
	background: transparent !important;
}

.dropdown-btn:hover {
	color: #08b0b9;
}

el-dropdown {
	width: 65px;
	height: 40px;
	display: flex;
	overflow: visible;
	flex-wrap: nowrap;
	white-space: nowrap;
	margin-top: -5px;
}

el-dropdown:hover .dropdown-menu {
	display: flex !important;
}

el-dropdown-menu {
	position: relative;
	display: none;
	flex-direction: column;
	background: #6e6b7b;
	color: white;
	padding: 10px;
	border-radius: 5px;
	right: 115px;
	margin-left: 5px;
	cursor: pointer;
	font-weight: 400;
	z-index: 999;
	height: fit-content;
}
</style>
